import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoordinatedSeasonDataListComponent } from './component/coordinated-season-data-list/coordinated-season-data-list.component';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownSeasonSelectComponent } from './component/dropdown-season-select/dropdown-season-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';



@NgModule({
  declarations: [CoordinatedSeasonDataListComponent, DropdownSeasonSelectComponent],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CoordinatedSeasonDataListComponent, DropdownSeasonSelectComponent]
})
export class SeasonModule { }
